import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNPatient } from 'src/app/models/cnpatient';

@Component({
  selector: 'app-protocol-dialog',
  templateUrl: './protocol-dialog.component.html',
  styleUrls: ['./protocol-dialog.component.scss']
})
export class ProtocolDialogComponent implements OnInit {

  public patient: CNPatient;
  public location: string;

  constructor(private dialogRef: MatDialogRef<ProtocolDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    if (typeof data.patient !== 'undefined') {
      this.patient = data.patient;
    }
    if (typeof data.location !== 'undefined') {
      this.location = data.location;
    }
  }

  ngOnInit(): void {
  }

}
